import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponseWithPagination } from 'services/api/types';
import type { CreateRoomBody, Room, RoomListRequest, UpdateRoomBody } from './types';

export const getRoomWithSubjectList = (
  params: RoomListRequest = {},
): Promise<ListResponseWithPagination<Room>> => {
  return appApi
    .get(`/rooms/with-subjects`, {
      params,
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить аудитории' });
      throw error;
    });
};

export const getRooms = (): Promise<ListResponseWithPagination<Room>> => {
  return appApi
    .get('/rooms', { params: { size: 2000 } })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить аудитории' });
      throw error;
    });
};

export const getRoomById = (roomId: number): Promise<Room> => {
  return appApi
    .get(`/rooms/${roomId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить аудиторию' });
      throw error;
    });
};

export const createRoom = (body: CreateRoomBody): Promise<Room> => {
  return appApi
    .post('/rooms', body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать аудиторию' });
      throw error;
    });
};

export const removeRoom = (roomId: number): Promise<void> => {
  return appApi
    .delete(`/rooms/${roomId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить аудиторию' });
      throw error;
    });
};

export const updateRoom = (roomId: number, body: UpdateRoomBody): Promise<Room> => {
  return appApi
    .put(`/rooms/${roomId}`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить аудиторию' });
      throw error;
    });
};
